import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { LoaderService } from './services/loader.service';

@Component({
    selector: 'app-root',
    template: `
        <app-loader *ngIf="isLoading$ | async"></app-loader>
        <header class="header" *ngIf="!_mediaObserver.isActive('xs') || (_mediaObserver.isActive('xs') && showHeader)">
            <div class="overlay"></div>
            <div fxFlex="nogrow" fxLayoutAlign="center center" fxLayoutGap="30px">
                <a fxFlex="40" routerLink="/">
                    <img [src]="env.logoSrc" />
                </a>
            </div>
            <div fxFlex></div>

            <div class="header-content">
                <h1>eDAT</h1>
                <p>
                    Este é o Sistema de Declaração de Sinistro de Trânsito Eletrônico do Município de <strong>{{ env.cidade }}</strong>
                </p>
                <hr />
            </div>

            <div fxFlex></div>

            <button [fxHide.gt-xs]="true" mat-stroked-button color="white" (click)="showHeader = false">Acessar</button>

            <div fxFlex></div>

            <div fxLayout="column" class="copy" fxLayoutAlign="center center" fxLayoutGap="10px">
                <div fxFlex="nogrow">
                    <a fxFlex="100px" href="https://www.tivic.com.br/" target="_blank">
                        <img src="assets/imagens/logo-tivic.png" />
                    </a>
                </div>
                <span>Sistema desenvolvido pela <a href="https://www.tivic.com.br" target="_blank">TIVIC</a></span>
                <span>v{{ env.version }}</span>
            </div>
            <div fxFlex="25px"></div>
        </header>
        <router-outlet></router-outlet>
    `,
    styleUrls: [`./app.component.scss`],
})
export class AppComponent implements OnInit {
    title = 'dat-web-angular';
    env: any = environment;
    date = new Date();

    isLoading$: Observable<boolean> = this._loaderService.isLoading.pipe(tap(() => this.onChanges()));
    showHeader: boolean = true;

    constructor(public _mediaObserver: MediaObserver, private _loaderService: LoaderService, private _detector: ChangeDetectorRef) {}

    ngOnInit(): void {}

    onChanges() {
        this._detector.detectChanges();
    }
}